"use client";

import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";
import type { BranchAddressDisplay } from "@/lib/branches/local-address";

/**
 * 지점 주소 두 줄 — `getBranchAddressDisplay` 결과만 그린다(규칙은 helper 한 곳).
 *
 * 첫 줄은 번역 주소(기존 표기), 둘째 줄은 작은 회색 줄로 "현지 주소" 라벨 + 원문 주소.
 * 번역이 비어 원문이 첫 줄로 올라오면(`primaryIsLocal`) 라벨도 첫 줄에 붙는다.
 * 원문 대상이 아니면 기존처럼 주소 한 줄. 글자 크기·색은 화면마다 다르므로 바깥에서 넘긴다.
 */
export default function BranchAddressLines({
  display,
  primaryClassName,
  secondaryClassName,
  className,
  truncate = false,
}: {
  display: BranchAddressDisplay;
  /** 첫 줄(주소) */
  primaryClassName?: string;
  /** 둘째 줄(현지 원문 주소) */
  secondaryClassName?: string;
  className?: string;
  /** 카드처럼 폭이 좁은 곳은 줄마다 말줄임 */
  truncate?: boolean;
}) {
  const t = useTranslations("product.locationMap");
  const label = (
    <span className="mr-1 inline-block rounded border border-gray-200 px-1 align-[1px] text-[10px] leading-3.5 font-normal text-gray-500">
      {t("localAddress")}
    </span>
  );

  return (
    <span className={cn("block min-w-0", className)}>
      <span className={cn("block", truncate && "truncate", primaryClassName)}>
        {display.primaryIsLocal && label}
        {display.primary}
      </span>
      {display.secondary && (
        <span
          className={cn(
            "mt-0.5 block text-xs text-gray-500",
            truncate && "truncate",
            secondaryClassName,
          )}
        >
          {label}
          {display.secondary}
        </span>
      )}
    </span>
  );
}
